import { Config } from '../constants/config';
import { ThemeMO } from '../models/ThemeMO';
import { ExclusionsMO } from '../models/ExclusionsMO';
import { LocalStorageManager } from '../Manager/LocalStorageManager';

export class ConfigManager {
	static getThemeByKey = (key: string) => {
		let idx = Config.ratingLabelPresets.findIndex((item) => item.key === key);
		let _preset = Config.ratingLabelPresets[idx];
		let _rating: string[] = [
			_preset.ratings[0],
			_preset.ratings[1],
			_preset.ratings[2],
			_preset.ratings[3],
			_preset.ratings[4],
		];
		let themeMo = LocalStorageManager.getThemeMOFromLocalStorage();
		if (key === Config.themeCustomKey) {
			if (themeMo != null && themeMo.customeThemeRatings != null) {
				_rating = themeMo.customeThemeRatings;
			}
		}
		return new ThemeMO(
			key,
			_preset.themeTitle,
			_preset.themeQuestion,
			_rating,
			themeMo && themeMo.customeThemeRatings,
		);
	};

	static getCustomThemeKey = () => {
		return Config.themeCustomKey;
	};

	static getDefaultTheme = () => {
		return ConfigManager.getThemeByKey(Config.themeDefault);
	};

	static getDefaultExclusions = () => {
		let ex = Config.exclusions;
		let _exclusionsMO = new ExclusionsMO(
			ex.parens,
			ex.singleQuotes,
			ex.doubleQuotes,
			ex.headings,
			ex.indentedParagraphs,
			ex.listItems,
			ex.tables,
			ex.wordCountLessThan,
			ex.customExclusion,
		);

		return _exclusionsMO;
	};

	static getRatingLabelPresets = () => {
		return Config.ratingLabelPresets;
	};

	static getPunctuation = () => {
		return Config.punctuation;
	};

	static getStrippedOutExclusionPunctuations = () => {
		return new RegExp(`[${Config.strippedOutExclusionPunctuations}]`, 'g');
	};

	static getMetrics = () => {
		return Config.metrics;
	};

	static getChunkLength = () => {
		return Config.chunkLength;
	};

	static getNodePerProcess = () => {
		return Config.nodePerProcess;
	};

	static getDelayPerProcess = () => {
		return Config.delayPerProcess;
	};

	// static getThemeRating = (key: string, rate: number) => {};
}
